/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/PostFilter/Primary/List
 * @desc Primary filters for experiment workflow
 */

import { FilterList } from 'labstep-web/components/Filter/List';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Header } from 'labstep-web/core/Header';
import { Icon } from 'labstep-web/core/Icon';
import { SignedTypes } from 'labstep-web/models/experiment-workflow.model';
import { PostFilterAssignedTo } from 'labstep-web/services/postFilter/filters/assignedTo';
import { PostFilterAuthor } from 'labstep-web/services/postFilter/filters/author';
import type React from 'react';
import type { ExperimentWorkflowPostFilterPrimaryListProps } from './types';

export const ExperimentWorkflowPostFilterPrimaryList: React.FC<
  ExperimentWorkflowPostFilterPrimaryListProps
> = ({ authenticatedUserEntity }) => (
  <div>
    <Header size="tiny">
      <Icon name="filter" />
      Filter Shortcuts
    </Header>
    <FilterList
      useURL
      filters={[
        {
          component: <Icon name="user" />,
          text: 'Created by me',
          params: {},
          postFilterValues: [
            PostFilterAuthor,
            [authenticatedUserEntity.guid],
          ],
        },
        {
          component: <Icon name="user plus" />,
          text: 'Assigned to me',
          params: {},
          postFilterValues: [
            PostFilterAssignedTo,
            [authenticatedUserEntity.guid],
          ],
        },
        {
          component: <Icon name={SignedTypes.unsigned.icon} />,
          text: 'For me to sign',
          params: {
            has_signature: undefined,
            has_signature_request: undefined,
            signature_request_user_id: String(
              authenticatedUserEntity.guid,
            ),
          },
        },
      ]}
    />
  </div>
);

export default withAuthenticatedUserEntity(
  ExperimentWorkflowPostFilterPrimaryList,
);
